import React from 'react';
import TilesComponent from '../components/tiles.jsx';
import { MdPinIcon64 } from '@miljodirektoratet/md-react';

function PageOpenLayers() {
  return (
    <div className="tiles-container">
      <TilesComponent 
        heading="WMS Timeslider" 
        icon={<MdPinIcon64 height={64} width={64} />} 
        href="./maps/openlayers/wms-timeslider/dist/index.html" /* Specify the target URL */
        mode="small" /* Change the size of the tile */
      />
    </div>
  );
}

export default PageOpenLayers;

